import React from "react";
import { EntityCrudPage } from "./EntityCrudPage";

export function ProjectsPage() {
  return (
    <EntityCrudPage
      title="Projects"
      subtitle="Manage project details for customers."
      endpoint="/api/Projects"
      customerScoped
      listColumns={[
        { key: "name", label: "Name" },
        { key: "description", label: "Description" },
        { key: "customerName", label: "Customer" },
        { key: "image", label: "Image", type: "image" },
        { key: "order", label: "Order" }
      ]}
      fields={[
        { key: "name", label: "Name", required: true },
        { key: "description", label: "Description", type: "textarea" },
        { key: "image", label: "Image", type: "image" },
        { key: "order", label: "Order", type: "number" }
      ]}
    />
  );
}
